"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferLabel = void 0;
const inferLabel = () => { };
exports.inferLabel = inferLabel;
